import React from 'react';
import { ImageBox } from '@cms/tpl';
import { Col, Row } from 'antd';

const IdentityPhotosBox = ({ ...props }) => {
  const fileNumber = props.value ? props.value.length : 0;
  const colSpan = fileNumber > 1 ? 12 : 24;

  return (
    <>
      {
        <Row gutter={[16, 16]}>
          {props.value && props.value.map((file) => (
            <Col key={file.name} span={colSpan}>
              <ImageBox
                header=''
                size={[-1, -1]}
                resize={true}
                key={file.name}
                value={file.url}
              />
              </Col>
          ))}
        </Row>
      }
    </>
  )
}

export default IdentityPhotosBox;